import { useRouter } from 'next/router';
import { detectLocale } from '@/utils/locale';

const COPY = {
  cs: { title: 'Stránka nebyla nalezena', description: 'Požadovaná stránka neexistuje.' },
  pl: { title: 'Nie znaleziono strony', description: 'Żądana strona nie istnieje.' }
};

const Page404 = () => {
  const router = useRouter();
  const { locale } = detectLocale(router.asPath || '/');
  const t = locale !== 'pl' ? COPY.cs : COPY.pl;

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">{t.title}</h1>
        <p className="text-gray-600">{t.description}</p>
      </div>
    </div>
  );
};
export default Page404;
